import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_TcmAssessmentChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_TcmAssessmentChild' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'> <h3>1. Demographics</h3></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Client Legal Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Age:</span></td>
                        <td className='w-375'><span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_Male' name='rbGender' className='add-only' value='Male' />  Male&nbsp;
                            <input type='radio' id='rb_Female' name='rbGender' className='add-only' value='Female' /> Female&nbsp;
                            <input type='radio' id='rb_Other' name='rbGender' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtGenderOther' name='txtGenderOther' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SSN:</span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSsn' name='txtSsn' className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Patient's Ethnicity (Please check all that apply): </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_Hispanic' name='rbEthnicity' className='add-only' value='Yes' /> Hispanic
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_Asian' name='rbEthnicity' className='add-only' value='No' /> Asian
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_African' name='rbEthnicity' className='add-only' value='No' /> Black/African American
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_White' name='rbEthnicity' className='add-only' value='White' /> White
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_NoAnswer' name='rbEthnicity' className='add-only' value='NoAnswer' /> Prefers not to answer this question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rb_OtherEthnicity' name='rbEthnicity' className='add-only' value='OtherEthnicity' /> Other (specify):
                            <input type='text' id='txtOtherEthnicity' name='txtOtherEthnicity' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Primary Language/Speech:</span></td>
                        <td className='w-375'><span className='eleHeader'>Secondary Language/Speech: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLanguage_1' name='txtLanguage_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtLanguage_2' name='txtLanguage_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Legal Guardian's Name: </span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship to client: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtGuardian_1' name='txtGuardian_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtRelationship_1' name='txtRelationship_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Legal Guardian's Name: </span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship to client:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtGuardian_2' name='txtGuardian_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtRelationship_2' name='txtRelationship_2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If the client is not the biological child of the Legal Guardian(s), has documentation issued by a court been presented, reviewed, and a copy made for chart?
                    </span>
                    <input type='radio' id='rb_BioChildYes' name='rbBioChild' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rb_BioChildNo' name='rbBioChild' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rb_BioChildNa' name='rbBioChild' className='add-only' value='Na' /> N/A
                </p>
                <p className='w-750'>
                    If no, please explain:
                    <textarea id='txtBioChildNo' name='txtBioChildNo' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>Address:</span></p>
                <table>
                    <tr>
                        <td className='w-375'><b>Street:</b></td>
                        <td className='w-375'><b>City:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtStreet' name='txtStreet' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>State:</b></td>
                        <td className='w-375'><b>Zip:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Telephone:</span></p>
                <table>
                    <tr>
                        <td className='w-375'><b>Home:</b></td>
                        <td className='w-375'><b>Cell:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHome' name='txtHome' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCell' name='txtCell' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Work:</b></td>
                        <td className='w-375'><b>Other:</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWork' name='txtWork' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Which phone do you prefer we call first?</span></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_CallFirstHome' name='rbCallFirst' className='add-only' value='Home' /> Home
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_CallFirstCell' name='rbCallFirst' className='add-only' value='Cell' /> Cell
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_CallFirstWork' name='rbCallFirst' className='add-only' value='Work' /> Work
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rb_CallFirstOther' name='rbCallFirst' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtCallFirstOther' name='txtCallFirstOther' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is it okay to leave a voicemail containing information about services being received with RPBH?
                    </span>
                    <input type='radio' id='rb_LeaveVoicemailYes' name='rbLeaveVoicemailContaining' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rb_LeaveVoicemailNo' name='rbLeaveVoicemailContaining' className='add-only' value='No' /> No
                    <span className='eleHeader'>If yes, which phones can we leave a voicemail?</span>

                    <input type='radio' id='rb_LeaveVoicemailHome' name='rbLeaveVoicemail' className='add-only' value='Home' /> Home&nbsp;
                    <input type='radio' id='rb_LeaveVoicemailCell' name='rbLeaveVoicemail' className='add-only' value='Cell' /> Cell&nbsp;

                    <input type='radio' id='rb_LeaveVoicemailWork' name='rbLeaveVoicemail' className='add-only' value='Work' /> Work&nbsp;
                    <input type='radio' id='rb_LeaveVoicemailOther' name='rbLeaveVoicemail' className='add-only' value='Other' /> Other&nbsp;

                    <input type='radio' id='rb_LeaveVoicemailEmergency' name='rbLeaveVoicemail' className='add-only' value='Emergency' /> Emergency Contact
                </p>
                <p className='w-750'><span className='eleHeader'>Emergency Contact</span></p>
                <table>
                    <tr>
                        <td className='w-250'><b>Name:</b></td>
                        <td className='w-250'><b>Telephone:</b></td>
                        <td className='w-250'><b>Relationship to Client: </b></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephone' name='txtTelephone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationshipClient' name='txtRelationshipClient' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Ref. Source:</span></td>
                        <td className='w-250'><span className='eleHeader'>Rel. to client:</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtRefSource' name='txtRefSource' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelClient' name='txtRelClient' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <h3>2. Family Information</h3></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Father's Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Father's DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSameAsAbove_1' name='cbSameAsAbove_1' className='add-only' value='SameAsAbove' /> Same as above</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFatherName' name='txtFatherName' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='date' id='txtFatherDob' name='txtFatherDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone:</span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSameAsAbove_2' name='cbSameAsAbove_2' className='add-only' value='SameAsAbove' /> Same as above</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFatherPhone' name='txtFatherPhone' className='add-only' /> </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Address:</span>
                    <input type='checkbox' id='cbSameAsAbove_3' name='cbSameAsAbove_3' className='add-only' value='SameAsAbove' /> Same as above
                    <input type='text' id='txtFatherAddress' name='txtFatherAddress' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Level of involvement in client's life? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_FatherRegular' name='rbFatherInvolvement' className='add-only' value='Regular' /> Regular/Consistent
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_FatherSporadic' name='rbFatherInvolvement' className='add-only' value='Sporadic' /> Sporadic/Limited
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_FatherNone' name='rbFatherInvolvement' className='add-only' value='None' /> None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_FatherExternalFactors' name='rbFatherInvolvement' className='add-only' value='ExternalFactors' /> External factors limit involvement:
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtFatherExternalfactors' name='txtFatherExternalfactors' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mother,s Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Mother,s DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSameAsAbove_4' name='cbSameAsAbove_4' className='add-only' value='SameAsAbove' /> Same as above</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMotherName' name='txtMotherName' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='date' id='txtMotherDob' name='txtMotherDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSameAsAbove_5' name='cbSameAsAbove_5' className='add-only' value='SameAsAbove' /> Same as above</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMotherPhone' name='txtMotherPhone' className='add-only' /> </td>

                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Address:</span>
                    <input type='checkbox' id='cbSameAsAbove_6' name='cbSameAsAbove_6' className='add-only' value='SameAsAbove' /> Same as above
                    <input type='text' id='txtMotherAddress' name='txtMotherAddress' className='add-only' />

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Level of involvement in client's life?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_MotherRegular' name='rbMotherInvolvement' className='add-only' value='Regular' /> Regular/Consistent
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_MotherSporadic' name='rbMotherInvolvement' className='add-only' value='Sporadic' /> Sporadic/Limited
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_MotherNone' name='rbMotherInvolvement' className='add-only' value='None' /> None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_MotherExternalFactors' name='rbMotherInvolvement' className='add-only' value='ExternalFactors' /> External factors limit involvement:
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMotherExternalfactors' name='txtMotherExternalfactors' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Any family history of mental illness? </span>

                    <input type='radio' id='rb_MentalIllnessYes' name='rbMentalIllness' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rb_MentalIllnessNo' name='rbMentalIllness' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If Yes, please describe:
                    <textarea id='txtMentalIllnessYes' name='txtMentalIllnessYes' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Is there any family history of physical/emotional/sexual abuse, neglect, or domestic violence? </span>
                    <input type='radio' id='rb_HistoryViolenceYes' name='rbHistoryViolence' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rb_HistoryViolenceNo' name='rbHistoryViolence' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If Yes, please describe:
                    <textarea id='txtHistoryViolenceYes' name='txtHistoryViolenceYes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, were authorities involved?</span>
                    <input type='radio' id='rbAuthoritiesInvolved_Yes' name='rbAuthoritiesInvolved' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAuthoritiesInvolved_No' name='rbAuthoritiesInvolved' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, are there any current DCF or legal investigations open?</span>
                    <input type='radio' id='rbCurrentDcf_Yes' name='rbCurrentDcf' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbCurrentDcf_No' name='rbCurrentDcf' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Please Explain:
                    <textarea id='txtCurrentDcf' name='txtCurrentDcf' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Was the client involved or did the client witness any of these events?</span>
                    <input type='radio' id='rbEvents_Yes' name='rbEvents' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbEvents_No' name='rbEvents' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there history or current traumatic circumstances?</span>
                    <input type='radio' id='rbHistory_Witnessed' name='rbHistory' className='add-only' value='Witnessed' /> Witnessed&nbsp;
                    <input type='radio' id='rbHistory_Experienced' name='rbHistory' className='add-only' value='Experienced' /> Experienced&nbsp;
                    <input type='radio' id='rbHistory_Na' name='rbHistory' className='add-only' value='Na' /> N/A
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there any family history of substance abuse?</span>
                    <input type='radio' id='rbFamilyHistoryAbuse_Yes' name='rbFamilyHistoryAbuse' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbFamilyHistoryAbuse_No' name='rbFamilyHistoryAbuse' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If Yes, please describe:
                    <textarea id='txtFamilyHistoryAbuse_Yes' name='txtFamilyHistoryAbuse_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client witnessed the use or intoxication of these substances by family members or other individuals involved in the client's life?</span>
                    <input type='radio' id='rbIntoxication_Yes' name='rbIntoxication' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbIntoxication_No' name='rbIntoxication' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Who currently resides in the home with the client? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-400'><span className='eleHeader'>Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Relationship to Client:</span></td>
                        <td className='w-100'><span className='eleHeader'>Age:</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_1' name='txtResidesName_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_1' name='txtResidesRelationshipClient_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_1' name='txtResidesAge_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_2' name='txtResidesName_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_2' name='txtResidesRelationshipClient_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_2' name='txtResidesAge_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_3' name='txtResidesName_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_3' name='txtResidesRelationshipClient_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_3' name='txtResidesAge_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_4' name='txtResidesName_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_4' name='txtResidesRelationshipClient_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_4' name='txtResidesAge_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_5' name='txtResidesName_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_5' name='txtResidesRelationshipClient_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_5' name='txtResidesAge_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_6' name='txtResidesName_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_6' name='txtResidesRelationshipClient_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_6' name='txtResidesAge_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_7' name='txtResidesName_7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_7' name='txtResidesRelationshipClient_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_7' name='txtResidesAge_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_8' name='txtResidesName_8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_8' name='txtResidesRelationshipClient_8' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_8' name='txtResidesAge_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_9' name='txtResidesName_9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_9' name='txtResidesRelationshipClient_9' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_9' name='txtResidesAge_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtResidesName_10' name='txtResidesName_10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtResidesRelationshipClient_10' name='txtResidesRelationshipClient_10' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtResidesAge_10' name='txtResidesAge_10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Who does the client describe as his/her primary support within the family? </span>
                    <textarea id='txtPrimarySupport' name='txtPrimarySupport' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How come? </span>
                    <textarea id='txtHowCome' name='txtHowCome' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Where was the client born? (City, State, Country): </span>
                    <textarea id='txtClientBorn' name='txtClientBorn' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the family and/or client have any religious or spiritual affiliation/beliefs:</span>
                    <input type='radio' id='rbReligiousBeliefs_Yes' name='rbReligiousBeliefs' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbReligiousBeliefs_No' name='rbReligiousBeliefs' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbReligiousBeliefs_NotAnswer' name='rbReligiousBeliefs' className='add-only' value='NotAnswer' /> Prefers not to answer this question.
                </p>
                <p className='w-750'>
                    Please specify:
                    <textarea id='txtReligiousBeliefs' name='txtReligiousBeliefs' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there any cultural or spiritual/religious beliefs that the treatment team should be made aware? </span>
                    <input type='radio' id='rbCulturalBeliefs_Yes' name='rbCulturalBeliefs' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbCulturalBeliefs_No' name='rbCulturalBeliefs' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbCulturalBeliefs_Na' name='rbCulturalBeliefs' className='add-only' value='Na' /> N/A&nbsp;
                    <input type='radio' id='rbCulturalBeliefs_NotAnswer' name='rbCulturalBeliefs' className='add-only' value='NotAnswer' /> Prefers not to answer this question.
                </p>
                <p className='w-750'>
                    Please specify:
                    <textarea id='txtCulturalBeliefs' name='txtCulturalBeliefs' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there any additional information pertaining to the family that should be noted?
                    </span>
                    <span className='small'>(Supportive relationships, discordant relationships, custody issues, adoption, abandonment, the death of family members, arrests, natural disasters, refugees, etc.)</span>
                    <textarea id='txtAdditionalInformation' name='txtAdditionalInformation' className='add-only'></textarea>
                </p>

                <p className='w-750'> <h3>3. Client Information</h3></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Academic status? </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_1' name='cbAcademicStatus_1' className='add-only' value='OnGradeLevel' /> On grade-level
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_2' name='cbAcademicStatus_2' className='add-only' value='HxRetention' /> Hx of retention
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_3' name='cbAcademicStatus_3' className='add-only' value='DroppedOut' /> Dropped out
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_4' name='cbAcademicStatus_4' className='add-only' value='Expelled' /> Expelled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_5' name='cbAcademicStatus_5' className='add-only' value='AlternativeSchool' /> Alternative School
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_6' name='cbAcademicStatus_6' className='add-only' value='Graduated' /> Graduated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_7' name='cbAcademicStatus_7' className='add-only' value='VocTradeSchool' /> Voc/Trade school
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcademicStatus_8' name='cbAcademicStatus_8' className='add-only' value='GedProgram' /> GED Program
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If there is a history of retention or expulsion, what grades?</span>
                    <textarea id='txtHistoryRetention' name='txtHistoryRetention' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Highest grade completed?</span></td>
                        <td className='w-375'><span className='eleHeader'>Previous Literacy reading level?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHighestGrade' name='txtHighestGrade' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='text' id='txtPreviousLiteracy' name='txtPreviousLiteracy' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Literacy reading level?</span></td>
                        <td className='w-375'><span className='eleHeader'>What school does the client attend?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrentLiteracy' name='txtCurrentLiteracy' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='text' id='txtClientSchool' name='txtClientSchool' className='add-only w-250 custom-add-only' />&nbsp;
                            <input type='checkbox' id='cbClientSchoolNa' name='cbClientSchoolNa' className='add-only' value='Na' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Type of classes:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTypeClasses_1' name='cbTypeClasses_1' className='add-only' value='RegEd' /> Reg Ed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTypeClasses_2' name='cbTypeClasses_2' className='add-only' value='Gifted' /> Gifted
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTypeClasses_3' name='cbTypeClasses_3' className='add-only' value='Ese' /> ESE
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTypeClasses_4' name='cbTypeClasses_4' className='add-only' value='RegEdEse' /> Reg Ed+ ESE
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTypeClasses_5' name='cbTypeClasses_5' className='add-only' value='Contained' /> Contained
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If ESE, has a psycho-educational evaluation been done?</span>
                    <input type='radio' id='rbPsychoEducational_Yes' name='rbPsychoEducational' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbPsychoEducational_No' name='rbPsychoEducational' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, has a copy been received for the chart? </span>
                    <input type='radio' id='rbCopy_Yes' name='rbCopy' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbCopy_No' name='rbCopy' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbCopy_Unable' name='rbCopy' className='add-only' value='Unable' /> Unable to locate
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If the client is in ESE classes, what academic distinctions have been given? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_1' name='cbAcademicDistinctions_1' className='add-only' value='Asd' />
                        </td>
                        <td className='w-325'>Autism Spectrum Disorder (ASD)</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_2' name='cbAcademicDistinctions_2' className='add-only' value='Dhh' />
                        </td>
                        <td className='w-325'>Deaf or Hard-of-Hearing (DHH)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_3' name='cbAcademicDistinctions_3' className='add-only' value='Dsi' />
                        </td>
                        <td className='w-325'>Dual-Sensory Impairment (DSI) Deaf-Blind</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_4' name='cbAcademicDistinctions_4' className='add-only' value='Ebd' />
                        </td>
                        <td className='w-325'>Emotional/Behavioral Disabilities E/BD)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_5' name='cbAcademicDistinctions_5' className='add-only' value='Gifted' />
                        </td>
                        <td className='w-325'>Gifted</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_6' name='cbAcademicDistinctions_6' className='add-only' value='Hh' />
                        </td>
                        <td className='w-325'>Homebound or Hospitalized (HH)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_7' name='cbAcademicDistinctions_7' className='add-only' value='Ind' />
                        </td>
                        <td className='w-325'>Intellectual Disabilities (InD)</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_8' name='cbAcademicDistinctions_8' className='add-only' value='Li' />
                        </td>
                        <td className='w-325'>Language Impairment (LI)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_9' name='cbAcademicDistinctions_9' className='add-only' value='Ohi' />
                        </td>
                        <td className='w-325'>Other Health Impairment (OHI)</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_10' name='cbAcademicDistinctions_10' className='add-only' value='Oi' />
                        </td>
                        <td className='w-325'>Orthopedic Impairment (OI)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_11' name='cbAcademicDistinctions_11' className='add-only' value='Sld' />
                        </td>
                        <td className='w-325'>Specific Learning Disability (SLD)</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_12' name='cbAcademicDistinctions_12' className='add-only' value='Si' />
                        </td>
                        <td className='w-325'>Speech Impairment (SI)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_13' name='cbAcademicDistinctions_13' className='add-only' value='Tbi' />
                        </td>
                        <td className='w-325'>Traumatic Brain Injury (TBI)</td>

                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_14' name='cbAcademicDistinctions_14' className='add-only' value='Vi' />
                        </td>
                        <td className='w-325'>Visual Impairment (VI)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='checkbox' id='cbAcademicDistinctions_15' name='cbAcademicDistinctions_15' className='add-only' value='Dd' />
                        </td>
                        <td className='w-375'>Prekindergarten Children with Developmental Delay (DD)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>History of suspensions or behavior problems at school? </span>
                    <input type='radio' id='rbHistorySuspensions_Yes' name='rbHistorySuspensions' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbHistorySuspensions_No' name='rbHistorySuspensions' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please provide the # amount for each in the last 12 months.
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>referrals:</span></td>
                        <td className='w-375'><span className='eleHeader'>suspensions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAmountReferrals' name='txtAmountReferrals' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='text' id='txttxtAmountSuspensions' name='txttxtAmountSuspensions' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbTruancy' name='cbTruancy' className='add-only' value='Truancy' /> Truancy&nbsp;
                    <input type='checkbox' id='cbIss_Oss' name='cbIss_Oss' className='add-only' value='IssOss' /> ISS/OSS
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>What is the client's favorite subject?</span></td>
                        <td className='w-375'><span className='eleHeader'>Least favorite? </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFavSubject' name='txtFavSubject' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtLeastSubject' name='txtLeastSubject' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Legal Guardian's perspective on client's academic performance: </span>
                    <textarea id='txtPerformance' name='txtPerformance' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the client's academic and career goals? </span>
                    <textarea id='txtGoals' name='txtGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client employed?  </span>
                    <input type='radio' id='rbEmployed_Yes' name='rbEmployed' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbEmployed_No' name='rbEmployed' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbEmployed_JobSeeking' name='rbEmployed' className='add-only' value='JobSeeking' /> Job Seeking
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>If employed, where?</span></td>
                        <td className='w-375'><span className='eleHeader'>Hours worked in a week?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEmployedWhere' name='txtEmployedWhere' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHoursWorked' name='txtHoursWorked' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Do the client and family have reliable transportation?</span>
                    <input type='radio' id='rbTransportation_Yes' name='rbTransportation' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbTransportation_No' name='rbTransportation' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, what means of transportation does the client and family have?</span>
                    <textarea id='txtTransportation' name='txtTransportation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any history or current medical concerns?</span>
                    <input type='radio' id='rbMedicalConcerns_Yes' name='rbMedicalConcerns' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbMedicalConcerns_No' name='rbMedicalConcerns' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    (If yes, please explain please list condition, treating physician, medications, age of onset, and duration):
                    <textarea id='txtListCondition' name='txtListCondition' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any Prenatal Exposure (drugs, alcohol)?  </span>
                    <input type='radio' id='rbPrenatalExposure_Yes' name='rbPrenatalExposure' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbPrenatalExposure_No' name='rbPrenatalExposure' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtPrenatalExposure_Yes' name='txtPrenatalExposure_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbImpairments_1' name='cbImpairments_1' className='add-only' value='Speech' /> Speech&nbsp;
                    <input type='checkbox' id='cbImpairments_2' name='cbImpairments_2' className='add-only' value='Language' /> Language&nbsp;
                    <input type='checkbox' id='cbImpairments_3' name='cbImpairments_3' className='add-only' value='Hearing' /> Hearing&nbsp;
                    <input type='checkbox' id='cbImpairments_4' name='cbImpairments_4' className='add-only' value='Vision' /> Vision (Impairments):&nbsp;
                    <input type='radio' id='rbImpairments_Yes' name='rbImpairments' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbImpairments_No' name='rbImpairments' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtImpairments_Yes' name='txtImpairments_Yes' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Pediatrician/Primary Care Physician:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrentPediatrician' name='txtCurrentPediatrician' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPediatricianTelephone' name='txtPediatricianTelephone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of last wellness check/physical/visit? </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtPediatricianVisit' name='txtPediatricianVisit' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Address:</span>
                    <input type='text' id='txtPediatricianAddress' name='txtPediatricianAddress' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Dentist:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrentDentist' name='txtCurrentDentist' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDentistTelephone' name='txtDentistTelephone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of last dental visit? </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDentistVisit' name='txtDentistVisit' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Address:</span>
                    <input type='text' id='txtDentistAddress' name='txtDentistAddress' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Immunizations current?</span>
                    <input type='radio' id='rbImmunizations_Yes' name='rbImmunizations' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbImmunizations_No' name='rbImmunizations' className='add-only' value='No' /> No
                </p>
                <p className='w-375'>
                    Date of the last Immunization:
                    <input type='date' id='txtImmunizationDate' name='txtImmunizationDate' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any current or a history of legal problems? </span>
                    <input type='radio' id='rbLegalProblems_Yes' name='rbLegalProblems' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbLegalProblems_No' name='rbLegalProblems' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explains (include any open cases, charges, DJJ placement, diversion programs, probation, JPO's name, etc.):
                    <br />
                    <textarea id='txtLegalProblems_Yes' name='txtLegalProblems_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please list any hobbies or activities the client finds enjoyable or expresses an interest in: </span>
                    <textarea id='txtListHobbies' name='txtListHobbies' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Who does the client identify as his/her support network? </span>
                    <textarea id='txtSupportNetwork' name='txtSupportNetwork' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client involved in an intimate relationship or have a history of being in a relationship?  </span>
                    <input type='radio' id='rbIntimateRelationship_Yes' name='rbIntimateRelationship' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbIntimateRelationship_No' name='rbIntimateRelationship' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, has the client ever experience violence in his/her intimate relationship(s)? </span>
                    <input type='radio' id='rbExperienceViolence_Yes' name='rbExperienceViolence' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbExperienceViolence_No' name='rbExperienceViolence' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtExperienceViolence_Yes' name='txtExperienceViolence_Yes' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Sexual  Orientation, Gender Identity & Expression</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>Sexual Orientation?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_1' name='cbSexualOrientation_1' className='add-only' value='Heterosexual' /> Heterosexual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_2' name='cbSexualOrientation_2' className='add-only' value='Homosexual' /> Homosexual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_3' name='cbSexualOrientation_3' className='add-only' value='Bisexual' /> Bisexual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_4' name='cbSexualOrientation_4' className='add-only' value='Asexual' /> Asexual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_5' name='cbSexualOrientation_5' className='add-only' value='Pansexual' /> Pansexual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualOrientation_6' name='cbSexualOrientation_6' className='add-only' value='Questioning' /> Questioning
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Gender Identity?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGenderIdentity_1' name='cbGenderIdentity_1' className='add-only' value='Transgender' /> Transgender
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGenderIdentity_2' name='cbGenderIdentity_2' className='add-only' value='GenderNeutral' /> Gender Neutral/Fluid
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGenderIdentity_3' name='cbGenderIdentity_3' className='add-only' value='Preferred' /> Preferred
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Pronoun:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPronoun_1' name='cbPronoun_1' className='add-only' value='He' /> He/Him/His
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPronoun_2' name='cbPronoun_2' className='add-only' value='She' /> She/Her/Hers
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPronoun_3' name='cbPronoun_3' className='add-only' value='They' /> They/Them/Theirs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPronoun_4' name='cbPronoun_4' className='add-only' value='Other' /> Other:
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPronoun_4' name='txtPronoun_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Sexually active?</span>
                    <input type='radio' id='rbSexuallyActive_Yes' name='rbSexuallyActive' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbSexuallyActive_No' name='rbSexuallyActive' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbSexuallyActive_NotAnswer' name='rbSexuallyActive' className='add-only' value='NotAnswer' /> Prefers not to answer this question.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have a reasonable (age appropriate) understanding of what “safe-sex” means?</span>
                    <input type='radio' id='rbSafeSex_Yes' name='rbSafeSex' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbSafeSex_No' name='rbSafeSex' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, does the client participate in “safe-sex” all of the time?</span>
                    <input type='radio' id='rbSafeSexAllTime_Yes' name='rbSafeSexAllTime' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbSafeSexAllTime_No' name='rbSafeSexAllTime' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, what methods?
                    <textarea id='txtSafeSexAllTime_Yes' name='txtSafeSexAllTime_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If client does engage in unsafe sexual practices, has the client ever been tested for STDs?</span>
                    <input type='radio' id='rbUnsafeSexualPractices_Yes' name='rbUnsafeSexualPractices' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbUnsafeSexualPractices_No' name='rbUnsafeSexualPractices' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, when and where?
                    <textarea id='txtUnsafeSexualPractices_Yes' name='txtUnsafeSexualPractices_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any history of contracting a STD?</span>
                    <input type='radio' id='rbContractingStd_Yes' name='rbContractingStd' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbContractingStd_No' name='rbContractingStd' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbContractingStd_NotAnswer' name='rbContractingStd' className='add-only' value='NotAnswer' /> Prefers not to answer this question.
                </p>
                <p className='w-750'>
                    If yes, please make sure it was listed in the medical portion of assessment.
                    <textarea id='txtContractingStd_Yes' name='txtContractingStd_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have an interest in being tested for STDs?</span>
                    <input type='radio' id='rbTestedStd_Yes' name='rbTestedStd' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbTestedStd_No' name='rbTestedStd' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbTestedStd_NotAnswer' name='rbTestedStd' className='add-only' value='NotAnswer' /> Prefers not to answer this section&nbsp;
                    <input type='radio' id='rbTestedStd_NotAge' name='rbTestedStd' className='add-only' value='NotAge' /> Not age appropriate
                </p>

                <p className='w-750'> <h3>3. Presenting Problem(s)/Treatment History </h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Please describe current problems and concerns regarding the client (including any substance abuse):</span>
                    <textarea id='txtCurrentProblems' name='txtCurrentProblems' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>When did these problems begin?</span></td>
                        <td className='w-375'><span className='eleHeader'>Age of onset?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProblemsBegin' name='txtProblemsBegin' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAgeOnset' name='txtAgeOnset' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How often do these problems occur (constantly/daily/weekly/during certain times or situations)?</span>
                    <textarea id='txtProblemOccur' name='txtProblemOccur' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 6 months have these problems:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_Worsened' name='rbWorsenedImprovedStayedSame' className='add-only' value='Worsened' /> Worsened
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_Improved' name='rbWorsenedImprovedStayedSame' className='add-only' value='Improved' /> Improved
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_StayedSame' name='rbWorsenedImprovedStayedSame' className='add-only' value='StayedSame' /> Stayed the same
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Where are these problems creating the greatest concern?
                        <span className='small'>(Please check all that apply.)</span>
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHome' name='cbHome' className='add-only' value='Home' /> Home
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSchool' name='cbSchool' className='add-only' value='School' /> School
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCommunity' name='cbCommunity' className='add-only' value='Community' /> Community
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAcrossSettings' name='cbAcrossSettings' className='add-only' value='AcrossSettings' /> Across all settings
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What interventions at home or school seem to be beneficial?</span>
                    <textarea id='txtInterventions' name='txtInterventions' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently receiving services or has the client ever received treatment for these problems?</span>
                    <input type='radio' id='rbReceivedTreatment_Yes' name='rbReceivedTreatment' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbReceivedTreatment_No' name='rbReceivedTreatment' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <b>If yes, please list providers: </b>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Provider's Name:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Provider Type</span>
                            <span className='small'>(Psychiatrist/Therapist/TCM/etc.):</span>
                        </td>
                        <td className='w-200'><span className='eleHeader'>Duration (m/y-m/y):</span></td>
                        <td className='w-90'><span className='eleHeader'>Beneficial:</span></td>
                        <td className='w-150'><span className='eleHeader'>Compliant w/ tx?</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'></td>
                        <td className='w-150'></td>
                        <td className='w-100'></td>
                        <td className='w-100'></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_1' name='txtProviderType_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_1' name='txtDurationFrom_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_1' name='txtDurationTo_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_1' name='rbBeneficial_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_1' name='rbBeneficial_1' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_1' name='rbCompliant_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_1' name='rbCompliant_1' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_2' name='txtProviderType_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_2' name='txtDurationFrom_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_2' name='txtDurationTo_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_2' name='rbBeneficial_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_2' name='rbBeneficial_2' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_2' name='rbCompliant_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_2' name='rbCompliant_2' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_3' name='txtProviderType_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_3' name='txtDurationFrom_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_3' name='txtDurationTo_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_3' name='rbBeneficial_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_3' name='rbBeneficial_3' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_3' name='rbCompliant_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_3' name='rbCompliant_3' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_4' name='txtProviderType_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_4' name='txtDurationFrom_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_4' name='txtDurationTo_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_4' name='rbBeneficial_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_4' name='rbBeneficial_4' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_4' name='rbCompliant_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_4' name='rbCompliant_4' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_5' name='txtProviderName_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_5' name='txtProviderType_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_5' name='txtDurationFrom_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_5' name='txtDurationTo_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_5' name='rbBeneficial_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_5' name='rbBeneficial_5' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_5' name='rbCompliant_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_5' name='rbCompliant_5' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_6' name='txtProviderName_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_6' name='txtProviderType_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_6' name='txtDurationFrom_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_6' name='txtDurationTo_6' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_6' name='rbBeneficial_6' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_6' name='rbBeneficial_6' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_6' name='rbCompliant_6' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_6' name='rbCompliant_6' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_7' name='txtProviderName_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_7' name='txtProviderType_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_7' name='txtDurationFrom_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_7' name='txtDurationTo_7' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_7' name='rbBeneficial_7' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_7' name='rbBeneficial_7' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_7' name='rbCompliant_7' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_7' name='rbCompliant_7' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtProviderName_8' name='txtProviderName_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderType_8' name='txtProviderType_8' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationFrom_8' name='txtDurationFrom_8' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDurationTo_8' name='txtDurationTo_8' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialYes_8' name='rbBeneficial_8' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbBeneficialNo_8' name='rbBeneficial_8' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantYes_8' name='rbCompliant_8' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantNo_8' name='rbCompliant_8' className='add-only' value='No' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client agree these problems merit concern</span>
                    <input type='radio' id='rbClientAgree_Yes' name='rbClientAgree' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbClientAgree_No' name='rbClientAgree' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If no, please explain:
                    <textarea id='txtClientAgree_No' name='txtClientAgree_No' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    If yes, what does the client think will be helpful in improving his/her life?
                    <textarea id='txtClientAgree_Yes' name='txtClientAgree_Yes' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently on any psychotropic medications? </span>
                    <input type='radio' id='rbPsychotropicMedications_Yes' name='rbPsychotropicMedications' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbPsychotropicMedications_No' name='rbPsychotropicMedications' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtPsychotropicMedications_Yes' name='txtPsychotropicMedications_Yes' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Name of medication</span></td>
                        <td className='w-70'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-70'><span className='eleHeader'>Freq.</span></td>
                        <td className='w-100'><span className='eleHeader'>Compliant (Uses as prescribed?)</span></td>
                        <td className='w-150'><span className='eleHeader'>Length of time client has been on this medication?</span></td>
                        <td className='w-115'><span className='eleHeader'>Side effects/Efficacy</span></td>
                        <td className='w-100'><span className='eleHeader'>Prescribing physician</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'></td>
                        <td className='w-150'></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_1' name='txtNameOfMedication_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_1' name='txtFreq_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_1' name='rbCompliantUses_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_1' name='rbCompliantUses_1' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_1' name='txtLengthOfTime_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_1' name='txtSideEffect_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_1' name='txtPrescribingPhysician_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_2' name='txtNameOfMedication_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_2' name='txtFreq_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_2' name='rbCompliantUses_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_2' name='rbCompliantUses_2' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_2' name='txtLengthOfTime_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_2' name='txtSideEffect_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_2' name='txtPrescribingPhysician_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_3' name='txtNameOfMedication_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_3' name='txtFreq_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_3' name='rbCompliantUses_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_3' name='rbCompliantUses_3' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_3' name='txtLengthOfTime_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_3' name='txtSideEffect_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_3' name='txtPrescribingPhysician_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_4' name='txtNameOfMedication_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_4' name='txtFreq_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_4' name='rbCompliantUses_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_4' name='rbCompliantUses_4' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_4' name='txtLengthOfTime_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_4' name='txtSideEffect_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_4' name='txtPrescribingPhysician_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_5' name='txtNameOfMedication_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_5' name='txtFreq_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_5' name='rbCompliantUses_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_5' name='rbCompliantUses_5' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_5' name='txtLengthOfTime_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_5' name='txtSideEffect_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_5' name='txtPrescribingPhysician_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_6' name='txtNameOfMedication_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_6' name='txtFreq_6' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_6' name='rbCompliantUses_6' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_6' name='rbCompliantUses_6' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_6' name='txtLengthOfTime_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_6' name='txtSideEffect_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_6' name='txtPrescribingPhysician_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtNameOfMedication_7' name='txtNameOfMedication_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtDosage_7' name='txtDosage_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFreq_7' name='txtFreq_7' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesYes_7' name='rbCompliantUses_7' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbCompliantUsesNo_7' name='rbCompliantUses_7' className='add-only' value='No' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtLengthOfTime_7' name='txtLengthOfTime_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffect_7' name='txtSideEffect_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPrescribingPhysician_7' name='txtPrescribingPhysician_7' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently receiving treatment or has the client ever received mental health treatment for any other issues? </span>
                    <input type='radio' id='rbClientCurrentlyReceivingTreatment_Yes' name='rbClientCurrentlyReceivingTreatment' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbClientCurrentlyReceivingTreatment_No' name='rbClientCurrentlyReceivingTreatment' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain:
                    <textarea id='txtClientCurrentlyReceivingTreatment_Yes' name='txtClientCurrentlyReceivingTreatment_Yes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    If yes, please list providers:
                    <input type='checkbox' id='cbClientCurrentlyReceivingTreatmentList_Yes' name='cbClientCurrentlyReceivingTreatmentList_Yes' className='add-only' value='ClientCurrentlyReceivingTreatmentList' /> Same as above
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Provider's Name:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Provider Type </span>
                            <span className='small'>(Psychiatrist/Therapist/TCM/etc.):</span>
                        </td>
                        <td className='w-200'><span className='eleHeader'>Duration (m/y-m/y):</span></td>
                        <td className='w-90'><span className='eleHeader'>Beneficial:</span></td>
                        <td className='w-150'><span className='eleHeader'>Compliant w/ tx?</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'></td>
                        <td className='w-150'></td>
                        <td className='w-100'></td>
                        <td className='w-100'></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderName_1' name='txtSameProviderName_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderType_1' name='txtSameProviderType_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationFrom_1' name='txtSameDurationFrom_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationTo_1' name='txtSameDurationTo_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialYes_1' name='rbSameBeneficial_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialNo_1' name='rbSameBeneficial_1' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantYes_1' name='rbSameCompliant_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantNo_1' name='rbSameCompliant_1' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderName_2' name='txtSameProviderName_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderType_2' name='txtSameProviderType_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationFrom_2' name='txtSameDurationFrom_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationTo_2' name='txtSameDurationTo_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialYes_2' name='rbSameBeneficial_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialNo_2' name='rbSameBeneficial_2' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantYes_2' name='rbSameCompliant_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantNo_2' name='rbSameCompliant_2' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderName_3' name='txtSameProviderName_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderType_3' name='txtSameProviderType_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationFrom_3' name='txtSameDurationFrom_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationTo_3' name='txtSameDurationTo_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialYes_3' name='rbSameBeneficial_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialNo_3' name='rbSameBeneficial_3' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantYes_3' name='rbSameCompliant_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantNo_3' name='rbSameCompliant_3' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderName_4' name='txtSameProviderName_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderType_4' name='txtSameProviderType_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationFrom_4' name='txtSameDurationFrom_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationTo_4' name='txtSameDurationTo_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialYes_4' name='rbSameBeneficial_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialNo_4' name='rbSameBeneficial_4' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantYes_4' name='rbSameCompliant_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantNo_4' name='rbSameCompliant_4' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderName_5' name='txtSameProviderName_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtSameProviderType_5' name='txtSameProviderType_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationFrom_5' name='txtSameDurationFrom_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSameDurationTo_5' name='txtSameDurationTo_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialYes_5' name='rbSameBeneficial_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameBeneficialNo_5' name='rbSameBeneficial_5' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantYes_5' name='rbSameCompliant_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSameCompliantNo_5' name='rbSameCompliant_5' className='add-only' value='No' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Please list any medications that the client has been prescribed in the past and explain why it was discontinued (ineffective, adverse side effects, cost, etc.):
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Reason it was discontinued
                            </span>
                            <span className='small'>(if due to adverse side effects, please describe reaction)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_3' name='txtReason_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_4' name='txtReason_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_5' name='txtReason_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtReason_6' name='txtReason_6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have a history of substance abuse? </span>
                    <textarea id='txtClientHistorySubstanceAbuse' name='txtClientHistorySubstanceAbuse' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    If yes, please explain (what substances, duration of use, and substance abuse treatment):
                    <textarea id='txtClientHistorySubstanceAbuse_Yes' name='txtClientHistorySubstanceAbuse_Yes' className='add-only'></textarea>
                </p>

                <p className='w-750'> <h3>4. Home Visit</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Was the home visit able to be completed in the client's home?</span>
                    <input type='radio' id='rbClientHome_Yes' name='rbClientHome' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbClientHome_No' name='rbClientHome' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If no, please explain:
                    <textarea id='txtClientHome_No' name='txtClientHome_No' className='add-only'></textarea>
                </p>
                <table>
                    <tr>

                        <td className='w-375'><span className='eleHeader'>TCM Signature: </span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='signature w-370'>&nbsp; </td>
                        <td className='w-375'>
                            <input type='date' id='txtTcmSignatureDate' name='txtTcmSignatureDate' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>TCM Supervisor: </span></td>
                        <td className='w-375'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTcmSupervisor' name='txtTcmSupervisor' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtTcmSupervisorDate' name='txtTcmSupervisorDate' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <span className='eleHeader'>Date of home visit?</span>
                    <input type='date' id='txtHomeVisitDate' name='txtHomeVisitDate' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Who was present during the home visit?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship to client</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_1' name='txtHomeVisitName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_1' name='txtHomeVisitRelationship_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_2' name='txtHomeVisitName_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_2' name='txtHomeVisitRelationship_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_3' name='txtHomeVisitName_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_3' name='txtHomeVisitRelationship_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_4' name='txtHomeVisitName_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_4' name='txtHomeVisitRelationship_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_5' name='txtHomeVisitName_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_5' name='txtHomeVisitRelationship_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitName_6' name='txtHomeVisitName_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHomeVisitRelationship_6' name='txtHomeVisitRelationship_6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Are there an adequate number of beds for number of people living in the home?</span>
                    <input type='radio' id='rbAdequateBeds_Yes' name='rbAdequateBeds' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAdequateBeds_No' name='rbAdequateBeds' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtAdequateBedsComments' name='txtAdequateBedsComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Adequate food?</span>
                    <input type='radio' id='rbAdequateFood_Yes' name='rbAdequateFood' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAdequateFood_No' name='rbAdequateFood' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtAdequateFoodComments' name='txtAdequateFoodComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Was the home clean and sanitary?</span>
                    <input type='radio' id='rbHomeClean_Yes' name='rbHomeClean' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbHomeClean_No' name='rbHomeClean' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtHomeCleanComments' name='txtHomeCleanComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there adequate cooking utensils?</span>
                    <input type='radio' id='rbAdequateCooking_Yes' name='rbAdequateCooking' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAdequateCooking_No' name='rbAdequateCooking' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtAdequateCookingComments' name='txtAdequateCookingComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Appropriate heating/air?</span>
                    <input type='radio' id='rbAppropriateHeating_Yes' name='rbAppropriateHeating' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAppropriateHeating_No' name='rbAppropriateHeating' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtAppropriateHeatingComments' name='txtAppropriateHeatingComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Pets in the home?</span>
                    <input type='radio' id='rbPetsInHome_Yes' name='rbPetsInHome' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbPetsInHome_No' name='rbPetsInHome' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtPetsInHomeComments' name='txtPetsInHomeComments' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any safety or security issues present?</span>
                    <input type='radio' id='rbSafetyIssues_Yes' name='rbSafetyIssues' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbSafetyIssues_No' name='rbSafetyIssues' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    Comments:
                    <textarea id='txtSafetyIssuesComments' name='txtSafetyIssuesComments' className='add-only'></textarea>
                </p>
                <p className='w-750'> <h3>5. Preferences and Expectations</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>What are some outcomes the family is hoping to obtain from treatment and targeted case management services? </span>
                    <textarea id='txtOutcomesFamily' name='txtOutcomesFamily' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are some outcomes the client is hoping to obtain from treatment and targeted case management services?</span>
                    <textarea id='txtOutcomesClient' name='txtOutcomesClient' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there any preferences or accommodations that the family or client feels the treatment team should be made aware of in order to increase the likelihood of successful treatment?
                    </span>
                    <span className='small'>(Right Path will ensure that any accommodations needed that are associated with a disability or language barrier will be addressed.  Preferences will be reviewed on a case-by-case basis and will be based on the availability of the agency's resources, as well as, the impact the accommodation(s) may have on effective treatment.):
                    </span>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'></textarea>
                </p>

                <p className='w-750'> <h3>6. Needs Assessment: Life Domain Worksheet and Key for Service Plan</h3></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Life Domains (Code):</span></td>
                        <td className='w-250'><span className='eleHeader'>Strengths:</span></td>
                        <td className='w-250'><span className='eleHeader'>Needs:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Family (F)</td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_1' name='txtStrengths_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_1' name='txtNeeds_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Education/Vocational/Employment (EVE)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_2' name='txtStrengths_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_2' name='txtNeeds_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Recreational/Leisure (RL)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_3' name='txtStrengths_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_3' name='txtNeeds_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Legal Assistance (LA)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_4' name='txtStrengths_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_4' name='txtNeeds_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Basic Needs/Benefits Access (BN)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_5' name='txtStrengths_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_5' name='txtNeeds_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Health/Mental Health (HMH)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_6' name='txtStrengths_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_6' name='txtNeeds_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Social Supports (SS)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_7' name='txtStrengths_7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_7' name='txtNeeds_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cultural/Spirituality (CS)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtStrengths_8' name='txtStrengths_8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtNeeds_8' name='txtNeeds_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Additional Comments:
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtStrengths_9' name='txtStrengths_9' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'> <h3>7. Collateral and Supporting Documents</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Targeted Case Manager:</span>
                    Please list any documentation and/or individuals, besides the legal guardian(s) and client, who provided information in the development of this Psychosocial Assessment:
                    <span className='small'>(Releases must be signed and in the chart)</span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Collateral Report from Providers, Referral Source, Extended family, Support System, etc.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship to Client</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportName_1' name='txtCollateralReportName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportRelationship_1' name='txtCollateralReportRelationship_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportName_2' name='txtCollateralReportName_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportRelationship_2' name='txtCollateralReportRelationship_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportName_3' name='txtCollateralReportName_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportRelationship_3' name='txtCollateralReportRelationship_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportName_4' name='txtCollateralReportName_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportRelationship_4' name='txtCollateralReportRelationship_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportName_5' name='txtCollateralReportName_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCollateralReportRelationship_5' name='txtCollateralReportRelationship_5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Supporting documents</span>

                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Type of Document</span></td>
                        <td className='w-375'><span className='eleHeader'>Received From</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsType_1' name='txtSupportingDocumentsType_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsReceived_1' name='txtSupportingDocumentsReceived_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsType_2' name='txtSupportingDocumentsType_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsReceived_2' name='txtSupportingDocumentsReceived_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsType_3' name='txtSupportingDocumentsType_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsReceived_3' name='txtSupportingDocumentsReceived_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsType_4' name='txtSupportingDocumentsType_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsReceived_4' name='txtSupportingDocumentsReceived_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsType_5' name='txtSupportingDocumentsType_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSupportingDocumentsReceived_5' name='txtSupportingDocumentsReceived_5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge/ Aftercare planning/ Transition:</span>
                    <textarea id='txtDischargeAftercareTransition' name='txtDischargeAftercareTransition' className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DSM V (ICD 10) Narrative Description:</span>
                    <b>Comprehensive Summary:</b>
                    <textarea id='txtComprehensiveSummary' name='txtComprehensiveSummary' className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}











